import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import { PersonNote20Regular, Speaker2Regular } from '@/components/Icon'
import styles from './index.module.scss'

export default function AssistantMessageOverflowMenu({
  menuId,
  menuAnchorEl,
  menuOpen,
  onClose,
  onNotes,
  onReadAloud,
  text,
  canSpeak,
}) {
  return (
    <Menu
      id={menuId}
      anchorEl={menuAnchorEl}
      open={menuOpen}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      slotProps={{
        paper: { elevation: 0, className: styles.menuPaper },
        list: { dense: true, className: styles.menuList },
      }}
    >
      <MenuItem onClick={onNotes} disabled={!onNotes} className={styles.menuItem}>
        <ListItemIcon className={styles.menuItemIconWrap}>
          <PersonNote20Regular className={styles.menuItemIcon} aria-hidden />
        </ListItemIcon>
        <ListItemText primary="Add to notes" primaryTypographyProps={{ className: styles.menuItemLabel }} />
      </MenuItem>
      <MenuItem onClick={onReadAloud} disabled={!text || !canSpeak} className={styles.menuItem}>
        <ListItemIcon className={styles.menuItemIconWrap}>
          <Speaker2Regular className={styles.menuItemIcon} aria-hidden />
        </ListItemIcon>
        <ListItemText primary="Read aloud" primaryTypographyProps={{ className: styles.menuItemLabel }} />
      </MenuItem>
    </Menu>
  )
}
